import { Link } from "react-router-dom";
import {
  CONTACT_EMAIL,
  COMPANY_LEGAL_NAME,
  COMPANY_CNPJ,
  COMPANY_COUNTRY,
  COMPANY_WEBSITE,
  COMPANY_WEBSITE_LABEL,
  PRODUCT_WEBSITE,
  PRODUCT_WEBSITE_LABEL,
} from "@/lib/company";

export function LandingFooter() {
  return (
    <footer className="border-t bg-card pt-10 pb-24 md:pb-10">
      <div className="container">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between">
          <div className="max-w-sm space-y-2 text-sm text-muted-foreground">
            <p className="text-base font-semibold text-foreground">MenuzAI</p>
            <p>AI-powered restaurant operations platform.</p>
            <p>
              A product developed by{" "}
              <a
                href={COMPANY_WEBSITE}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                {COMPANY_LEGAL_NAME}
              </a>
              .
            </p>
          </div>

          <div className="space-y-2 text-sm text-muted-foreground">
            <p className="text-base font-semibold text-foreground">Contato</p>
            <p>
              <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-foreground">{CONTACT_EMAIL}</a>
            </p>
            <p>
              <a href={PRODUCT_WEBSITE} target="_blank" rel="noopener noreferrer" className="hover:text-foreground">
                {PRODUCT_WEBSITE_LABEL}
              </a>
            </p>
            <p>CNPJ: {COMPANY_CNPJ}</p>
            <p>{COMPANY_COUNTRY}</p>
          </div>

          <div className="space-y-2 text-sm text-muted-foreground">
            <p className="text-base font-semibold text-foreground">Links</p>
            <p><Link to="/terms" className="hover:text-foreground">Termos</Link></p>
            <p><Link to="/privacy" className="hover:text-foreground">Privacidade</Link></p>
            <p><Link to="/contato" className="hover:text-foreground">Contato</Link></p>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-2 border-t pt-6 text-xs text-muted-foreground md:flex-row md:items-center md:justify-between">
          <p>© 2026 MenuzAI. Todos os direitos reservados.</p>
          <p>
            MenuzAI is a product of{" "}
            <a
              href={COMPANY_WEBSITE}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground"
            >
              {COMPANY_LEGAL_NAME}
            </a>{" "}
            ({COMPANY_WEBSITE_LABEL}).
          </p>
        </div>

        <div className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-muted-foreground md:justify-start">
          <Link to="/" className="hover:text-foreground">Início</Link>
          <Link to="/funcionalidades" className="hover:text-foreground">Funcionalidades</Link>
          <Link to="/pricing" className="hover:text-foreground">Planos</Link>
          <Link to="/sobre" className="hover:text-foreground">Sobre</Link>
        </div>
      </div>
    </footer>
  );
}
